<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-3"></a><a href="#/toc#toc-chapter003">2</a></h1>
<h1 class="chapter-title"><a href="#/toc#toc-chapter003"></a></h1>
<p class="noindent"><span class="dropcap">S</span>ome men were born heroes. Mitch Turner wasn’t one of them. Heroes, even humble ones, drew the spotlight. And the last thing
         Mitch wanted was attention.
      </p>
<p>But when his pickup rumbled over the old wooden bridge that cut the town of Crossroads, Tennessee, in two, the universe had
         other ideas. So did the eleven-year-old beside him.
      </p>
<p>“Dad—wait! Look!”</p>
<p>He saw it at the same time. A small form on top of the bridge rail.</p>
<p>“What’s she doing?” Jules asked.</p>
<p>But it was obvious. He stopped the truck. “Wait here.”</p>
<p>“But—”</p>
<p>He firmed up the order. “Wait here.” He dove out the door.</p>
<p class="space-break">Julia Turner watched the girl on the bridge turn as Mitch raced toward her. For a minute, Julia stopped breathing. Then the
         air exploded out of her as the girl turned back to the river and did the unthinkable.
      </p>
<p><a id="page-4"></a>Flew into the air.
      </p>
<p>Julia gripped the dashboard, her mouth hanging open. Then her dad sailed over the rail after her.</p>
<p>Julia yanked off her seat belt and leaped out of the truck. In a heartbeat she was at the railing. There he was, bobbing in
         the water, turning in every direction. From where she was, Julia had the better view.
      </p>
<p>“Dad!” She pointed to her right, where several hundred yards away, long strands of scraggly red hair were sinking beneath
         the water.
      </p>
<p>In seconds, strong strokes took her dad there. He disappeared below the blackness, and for a few horrible moments it looked
         like he might not come back.
      </p>
<p>But he popped up at last, gasping for air and tugging something with him.</p>
<p>He did it! He actually did it!</p>
<p>Julia rushed back to the truck. The keys were still in it, but the engine was off. Just as she’d seen Mitch do a thousand
         times, she turned the key, and when the engine only coughed but didn’t start, she said the same thing she’d heard her dad
         say.
      </p>
<p>“Dammit, old girl, don’t do this to me.”</p>
<p>The charm worked. The engine turned over, and she wrenched the seat as close to the pedals as possible. She still wasn’t tall
         enough to reach them and see where she was going, but by fits and starts, she managed to get the truck down the bridge to
         the other side where her dad was heading.
      </p>
<p>She set the brake carefully, then dashed out again and grabbed an old blanket from the truck bed. It was dirty and leaf-strewn
         because her dad used it to haul stuff, but she snatched it anyway, scampered around the edge of <a id="page-5"></a>the bridge, and slid down the bank to the river. Her father was approaching, using one arm to swim while the other cradled
         the small body he’d rescued.
      </p>
<p>“Over here!” Julia jumped up and down, waving her arms.</p>
<p>At last the water was shallow enough for Mitch to stand. He shifted the girl into both his arms and carried her to the shore.
         Dripping wet, he stumbled up the bank and laid the girl on the blanket. Julia thought he was going to fall down he was breathing
         so hard.
      </p>
<p>“Is she okay?”</p>
<p>The girl’s eyes were closed, and she looked all scrunched up and tiny. More like a doll than a person.</p>
<p>Mitch wiped water off his face. “I don’t know.”</p>
<p>He started pumping the girl’s chest and blowing into her mouth and pumping her chest again.</p>
<p>Endless minutes of nothing but the sound of her dad working on the small body. Then… another miracle—the girl coughed, groaned,
         and opened her eyes.
      </p>
<p>“There we go,” her dad said softly. “Welcome back.”</p>
<p class="space-break">Mitch’s arms trembled with exhaustion. Every muscle ached and he wanted to collapse on the ground for a week. Not for the
         first time, he wished he had a cell phone. A few buttons and someone else could take over. But phones and credit cards and
         accounts of every kind were a thing of the past. And any kind of authority—police, EMT—would have questions he didn’t want
         to answer.
      </p>
<p>“Hey,” Julia said. “What’s your name?”</p>
<p>The girl startled, seemed to see them for the first time, and started to sob.</p>
<p>He told Julia to wait while he got the truck, but she <a id="page-6"></a>thumbed over her shoulder with a triumphant, mischievous look. Their dusty black pickup was already at the near end of the
         bridge. Half of him wanted to scold her; the other half wanted to pin a medal on her.
      </p>
<p>He chucked her under the chin. “Good work, soldier.”</p>
<p>She smiled happily, like he knew she would, and as it often did, it took his breath away. She would be a mankiller someday.
         Every inch of her inherited beauty was there in her face. The silky dark hair, the amazing blue eyes. He was going to have
         a handful if he wasn’t careful.
      </p>
<p>But he was careful. He was always careful.</p>
<p class="space-break">Mitch hadn’t originally planned to stop in town. But the girl had abandoned a backpack when she went into the river. Inside,
         a wallet told them her name was Sara Jean Blunt and she lived in Crossroads.
      </p>
<p>The address took them in the direction they were already heading—across the bridge to the better side of town. Her house was
         at the top of the hill that overlooked the river and the flats, with its sprawl of cramped homes and old warehouses. Mitch
         stopped in front of a large clapboard house, a well-maintained Victorian wonder, with turrets and angles and a wide, wraparound
         porch. The geography and the architecture told him everything he needed to know about the girl’s family and their position
         in the town.
      </p>
<p>Beside him, Sara Jean was shuddering inside the blanket, sniffling and weeping quietly as if afraid to let him hear. He got
         out, came around, and lifted her off the seat. She shivered in his arms while Julia bounced beside them.
      </p>
<p>“Is this where you live? Wow, it’s so big. Do you have <a id="page-7"></a>your own room? Can you see it from here? What color is it? Do you have a TV?”
      </p>
<p>“Down, girl. Let’s get Sara Jean inside. She’s tired.”</p>
<p>He knocked on the door, and when she saw where they were, Sara Jean groaned. “Oh, God.” She looked up at him, her eyes wide
         and filled with tears. “Don’t tell them. Please. Promise me you won’t tell them. They’ll be so disappointed.” She hiccupped.
         “I’m so… so tired of being a disappointment.”
      </p>
<p>A shard of sympathy struck him. He knew all about disappointing people. “I’m sure you’re not a disappoint—”</p>
<p>“Look at me!” She threw off the blanket. “I’m too tall and too skinny, and my hair is this awful red, and everyone calls me
         Sara Jean Butt!”
      </p>
<p>Clichés tumbled through his head—kids can be stupid, so ignore them; everyone goes through an awkward stage; toughen up and
         fight back—but sometimes the only way to protect yourself was to hide the truth. He’d spent most of his life in deep cover,
         so he should know.
      </p>
<p>Fortunately, he was saved from replying by a small, trim woman with the same head of burning red hair as Sara’s. “Mrs. Blunt?”</p>
<p>She screeched when she saw her daughter. “Oh, my God, Sara Jean, what happened?”</p>
<p>Mitch pushed past her. Made a split-second decision. “She… she fell into the river.”</p>
<p>Out of the corner of his eye, he saw Julia open her mouth. He nudged her with his elbow to shut up. Not that Mrs. Blunt was
         listening.
      </p>
<p>“The river? Dear Lord, Sara Jean, what on earth were you doing—”</p>
<p>“Where’s her room?” Mitch interrupted, turning <a id="page-8"></a>around with the wet child in his arms. “You should get her out of these clothes.”
      </p>
<p>With rapid steps, she led the way to a staircase, and Mitch and Julia followed her up to the second floor. “Are you all right?”
         she asked her daughter. “You didn’t break anything, did you? How’s your ankle? She broke her ankle last summer,” she explained
         quickly to Mitch.
      </p>
<p>Sara Jean’s room was a flurry of pink and white. Ruffled pillows fluffed up the bed; balloons and teddy bears danced on the
         walls. It was the kind of room that made a man feel wildly uncomfortable but that little girls everywhere loved. Julia was
         no exception. He watched in regret as she gasped and gawked at the dolls and stuffed animals—all the trappings of the girlhood
         she never had and never would.
      </p>
<p>Mitch laid Sara Jean on the bed. “You’ll be okay now.”</p>
<p>An unspoken message passed between them. “Thanks,” she said.</p>
<p>Mitch nodded, hoping he’d done the right thing. If nothing else, he’d done the convenient thing. The choice that would get
         him and Julia out of there fast. There was still time to make it to Nashville and from there head south to the Gulf. “Come
         on, Jules. Let’s go.”
      </p>
<p>“Wait,” Sara Jean’s mother said. She was scrambling around the room, collecting dry clothes and towels from the bathroom.
         “Please.”
      </p>
<p>“That’s okay,” Mitch said. “We gotta hit the road.”</p>
<p>“No, we don’t,” Julia said.</p>
<p>“Jules,” Mitch warned.</p>
<p>“Don’t have a job to go to, no one waiting on us.”</p>
<p>“You’re out of work?” Sara Jean’s mother looked <a id="page-9"></a>concerned. A couple of years ago, being unemployed was like having leprosy—only the poor and shiftless caught it. Now, so
         many people were out of work it was almost a pandemic. “Do you live in town?”
      </p>
<p>Mitch opened his mouth, but Julia got there first. “No, ma’am. We don’t live nowhere.”</p>
<p>“Anywhere,” Mitch corrected. “And we’re <em>fine</em>.” He emphasized the last word with another meaningful look at Julia. She scowled at him.
      </p>
<p>Mrs. Blunt seemed to sum up the situation. “I’m sure you are, but I couldn’t live with myself if I didn’t thank you properly.
         I’ve got chocolate chip cookies downstairs.” Julia’s eyes lit up. “If you’ll just wait until I can get Sara Jean dried off…”
      </p>
<p>Jules took his hand and tugged him away. “Be happy to.” She smiled.</p>
<p>But when they were in the hallway, Mitch yanked his hand away. “What do you think you’re doing?”</p>
<p>“Nothing.”</p>
<p>“You’re damn right. Because we’re going.”</p>
<p>She hopped down the stairs and plopped onto one of the chairs that sat on either side of a table in the foyer. Crossing her
         arms and setting her mouth, she shot him a “make me” look.
      </p>
<p>He knew that look. “Come on, Junebug,” he wheedled. “You know the rules.”</p>
<p>“I hate your stupid rules,” she said. “One of these days, I’m gonna be old enough to make my own rules.”</p>
<p>“Well, until then you’re living by mine. And rule number one is we don’t talk about our troubles, and rule number two is we
         don’t get involved in other people’s.”
      </p>
<p>“Then why’d you jump in the river?”</p>
<p><a id="page-10"></a>“That’s different. I couldn’t exactly watch Sara Jean drown.”
      </p>
<p>“Well, I can’t let her poor mother feel guilty about not thanking us properly.”</p>
<p>“Okay, that’s it.” He pulled her up. She weighed no more than a pea, so it wasn’t hard. “We’re going.”</p>
<p>“I’ll scream. I’ll tell them you beat me.” He dragged her toward the door. “Mrs. Blunt! Mrs. Blunt!”</p>
<p>“Stop that.”</p>
<p>“Oh,” she groaned at the top of her voice, “I’m sooo hungry. Can’t remember when I ate last.”</p>
<p>“You little—”</p>
<p>“Mrs. Bluuuunnnnt!!”</p>
<p>Mitch threw up his hands. “Okay, okay.” He held up a finger. “One cookie.”</p>
<p>“And a glass of milk.”</p>
<p>“All right. One cookie and a glass of milk. And no talking about us.”</p>
<p>The commotion brought Sara Jean’s mother running down the stairs. “Everything all right?”</p>
<p>“Just fine,” Mitch said, a wary eye on the kid.</p>
<p>Sara Jean’s mother brightened a bit. “I put Sara Jean to bed. She”—the mother’s eyes darted away and back again—“she wasn’t
         up to talking. Would you mind?” She gestured for them to follow her into the house, and they walked through the rooms with
         their heavy farmhouse replicas, the rugs and ceramics, not to mention family pictures. Julia’s eyes popped and a look of worshipful
         awe crossed her face.
      </p>
<p>The kitchen was large and bright. A dining area was carved out of one corner, where a window looked out on a tree-filled backyard.
         In lieu of chairs, a wooden bench sat <a id="page-11"></a>below the window, and Julia bounded onto it, gazing at the yard’s October harvest of gold and red leaves.
      </p>
<p>But Mitch knew her focus was probably on one tree in particular, where a homemade swing hung alone and idle.</p>
<p>Sara Jean’s mother made coffee, and while they waited for it to brew, she brought a plate of cookies to the table. Mitch thought
         it better all around for Julia to be gone for this part, so he let her take a cookie, then gestured toward the window.
      </p>
<p>“Go ahead,” he told her.</p>
<p>She didn’t need a second invitation. She whooped, grabbed another cookie, and dashed out the back door. He sat across from
         the window, where he could keep an eye on her. She leaped onto the swing and was airborne in seconds.
      </p>
<p>“She’s adorable,” Mrs. Blunt said with an edge of wistfulness. “You and your wife must be very proud of her.”</p>
<p>Mitch nodded, his gaze still on his girl. “I am. But my wife… Julia’s mother passed away.”</p>
<p>“Oh, I’m so sorry.”</p>
<p>“Thank you. It was a long time ago. Julia was just a baby.”</p>
<p>“Well, you’ve done an amazing job with her. I wish… I wish Sara Jean could be that happy again.” She brought Mitch his coffee,
         which he sipped gratefully. He was still wearing his wet clothes, and his skin was icy.
      </p>
<p>Mrs. Blunt noticed the shiver that went through him. “Good gracious,” she exclaimed. “I can’t believe I’ve left you in those
         wet clothes.”
      </p>
<p>“That’s okay. We’re not stay—”</p>
<p>“Don’t be ridiculous. Let me get you something of <a id="page-12"></a>Tommy’s, my husband…” She was already pushing him out the door and into a laundry room off the kitchen. “Stay here and I’ll
         bring you something. Then we can just pop this stuff into the machine and be done with it.”
      </p>
<p>She was back in a few minutes with a pair of sweatpants and a T-shirt, which he dutifully put on, though the shirt barely
         covered his midsection and the sweatpants reached only to the top of his ankles.
      </p>
<p>“Well, at least they’re dry,” she said when she saw him.</p>
<p>He padded back to the kitchen in bare feet and saw Julia still happily ensconced on the swing. A few minutes later, Mrs. Blunt
         came back, poured herself a cup of coffee, and joined him at the table.
      </p>
<p>“Now,” she said brightly, though there was the glisten of tears in her eyes. “Tell me what really happened at the river.”</p>
<p>Mentally, he groaned. The house with its cozy warmth was like flypaper—no matter how hard he tried, his feet kept sticking.
         But he couldn’t bring himself to lie again.
      </p>
<p>When he was done, tears snaked down her cheeks and she put her hand on his arm. “God bless you,” she said. “If you hadn’t
         been there…”
      </p>
<p>“I promised her I wouldn’t tell you. She seems to think you wouldn’t understand.”</p>
<p>Sara Jean’s mother sighed sadly. “She’s right. I don’t.”</p>
<p>“Maybe she needs someone else to talk to.”</p>
<p>“Someone else? Oh, you mean a therapist. I don’t know. We’re not much on that kind of thing here.”</p>
<p>Mitch remained silent. Wasn’t his problem.</p>
<p>The front door slammed closed. “Bitsy?”</p>
<p>Mrs. Blunt—Bitsy—rose. “In here!”</p>
<p><a id="page-13"></a>A worried-faced woman rushed into the kitchen, toting an overstuffed briefcase and an armful of binders. She dropped everything
         on one of the counters and flew to Bitsy, who burst into tears and rushed into her arms. The two women hugged, the newcomer
         tall and rangy next to the petite redhead.
      </p>
<p>“Is she all right?” the newcomer asked.</p>
<p>Bitsy nodded, sniffing and swiping at her eyes.</p>
<p>“What on God’s earth happened?” She suddenly seemed to notice they weren’t alone. She stopped short, looked pointedly at Mitch.
         “Who are you?”
      </p>
<p>“Oh, God,” Bitsy said. “That’s… that’s—” She reddened, and clamped a hand over her mouth. “I don’t even know his name,” she
         wailed. “My manners, my head just… just—”
      </p>
<p>He rose, extended a hand. “Mitch Turner.”</p>
<p>“Hannah Blunt,” the taller woman said. “Sara Jean is my niece.” She looked him up and down, taking in the too-short shirt
         and pants. “And you are?”
      </p>
<p>“He saved her,” Bitsy rushed in. “He’s the one who pulled her out of the river. If it wasn’t for him, Sara Jean would be…
         would be—” She dissolved into sobs, and Hannah put an arm around her.
      </p>
<p>Another door slammed, and a third person ran into the kitchen. Mitch assumed this was the husband, Tommy. He threw his briefcase
         on the counter, too, and, as Hannah had done, ran to hold his wife.
      </p>
<p>The resemblance between the two newcomers was plain, and Mitch judged them to be brother and sister, though the woman—Hannah—was
         the taller of the two and clearly the one less interested in first impressions. While Tommy looked like he owned Brooks Brothers,
         <a id="page-14"></a>she looked like she’d spent the last week in the shapeless black dress she wore.
      </p>
<p>But if her clothes were dull, her intelligence was not. She gave him a sharp look and took him aside.</p>
<p>“What happened? And tell me exactly. Don’t leave anything out.”</p>
<p>That intense look, the firm tone, and the intent of the question were all too familiar. “You a cop?”</p>
<p>Her brows rose. “A lawyer.”</p>
<p>Cop. Lawyer. Different sides of the same coin. And not one he wanted to get near.</p>
<p>He held up his hands. “Look, all I did was pull the girl out of the river. If Mrs. Blunt hadn’t insisted, we’d already be
         on our way.”
      </p>
<p>“We?”</p>
<p>He thumbed over his shoulder. “Jules and I.”</p>
<p>Hannah looked out the window and back at him. He didn’t like the suspicion in her face. In fact, he didn’t like anything about
         her.
      </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter003.vue?4bba95c3